/* eslint-disable import/extensions */
import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Formik } from 'formik'

import { Box, Button, Card, Divider, Typography } from '@material-ui/core'

import billingSchema from './Billing.schemas'
import BillingForm from './BillingForm'

import { selectDocId } from '~/customer/store/customer.selectors'
import { selectBillingForm } from '~/payments/store/payments.selectors'
import PATHS from '~/router/paths'
import useScrollToFirstError from '~/sale/hooks/useScrollToFirstError'
import { selectCanContinue, selectIsPostpaid } from '~/sale/store'

export default function BillingPage() {
  const history = useHistory()
  const canContinue = useSelector(selectCanContinue)
  const initialValues = useSelector(selectBillingForm)
  const wrapper = useRef(null)
  const isPostpaid = useSelector(selectIsPostpaid)
  const { setValdationStatus } = useScrollToFirstError(wrapper)

  const docId = useSelector(selectDocId)
  function onSubmit() {
    if (canContinue) {
      history.push({
        pathname: PATHS.SUMMARY,
        search: location.search,
      })
    } else {
      setValdationStatus(true)
    }
  }

  const schema = billingSchema(isPostpaid, docId)
  return (
    <div ref={wrapper} data-hook="billing-page">
      <Box>
        <Box component={Card} borderRadius="14px">
          <Box py="20px" px="24px">
            <Typography variant="h3">Facturación</Typography>
          </Box>
          <Divider />
          <Box mt="24px" mb="32px">
            <Formik
              validateOnMount
              validateOnBlur
              initialValues={initialValues}
              validationSchema={schema}
              initialStatus={{}}
              onSubmit={onSubmit}
              component={BillingForm}
            />
          </Box>
        </Box>
        <Box mt="24px" display="flex">
          <Box>
            <Button
              onClick={onSubmit}
              data-hook="continue-btn"
              type="submit"
              variant="contained"
              color="secondary"
            >
              Continuar
            </Button>
          </Box>
          <Box pl="12px">
            <Button
              data-hook="back-btn"
              variant="outlined"
              color="secondary"
              onClick={() => history.push({ pathname: PATHS.OFFER_SETUP, search: location.search })}
            >
              Atrás
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  )
}
